import { useEffect, useState } from "react"
import { READ_SINGLEQR, SAVE_SINGLEQR, REMOVE_QRCOMP } from '../../../../../config/api'
import { iconwrapper, Retrieve_personal_info } from "../../../../../config/commonfunctions"
import { Banners, Checkdevice, Etsydummypanel, Loading, Modcfm, Noti, Portalmodal, refresh } from "../../../../../components"
import { ARROWLEFT_ICON, ENGLISH_FF, e_fs, LOOKUPUNSTYLE_ICON, PLOBJ } from "../../../../../config/constants"
import { COLOR_ICON, FRAME_ICON, LAPTOP_ICON, DOWNLOAD_ICON, MOBILE_ICON, TRASH_ICON, GRID_ICON, RESIZE_ICON, ITINERARYTEMPLATE_ICON, PRINT_ICON } from "../../../../../config/svgicons"
import { Link } from "react-router-dom";
import { Togglebutton } from "../../../../../basic_components"
import { multiplechoice_dom, partialtitle_dom, input_dom, textarea_dom, inputdescribe_dom, radiobtn_dom, checkbox_dom } from "../../Invitationmaker/components/Commonelements/Commonelements"
import { HexColorInput, HexColorPicker } from "react-colorful"
import { bannernames, banners } from "../../../../../assets/invitationcard/index1"
import Qrlookup from '../../../../Qrlookup/Qrlookup';
import html2canvas from "html2canvas"
import { changeDpiBlob } from "changedpi"
import axios from 'axios'


const s_ = { width: 30, height: 40, verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }
const vb_ = "0 0 1024 1024"
const v_ = "1.1"
const x_ = "http://www.w3.org/2000/svg"

const txtarea_css = { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, padding: '0px 10px' }

const TEMPLATE_CONTENT = {
    'Wedding QR Template ': [
        {
            title: 'Wedding Ceremony',
            description: '',
            bgcolor: '#fffff8',
            data: [{ "component": "TEXT", "content": "Scan", "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Lavishly Yours", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 122, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 99, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 165, "marginBottom": 0, "marginTop": 0 } } }, { "component": "TEXT", "content": `WEDDING CEREMONY PROGRAMME`, "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Lato", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 18, "marginBottom": 10, "marginTop": 0 }, "M": { "fontSize": 16, "marginBottom": 5, "marginTop": 0 }, "P": { "fontSize": 25, "marginBottom": 15, "marginTop": 0 } } }, { "component": "QR", "url": "wwww.neopets.com", "color": "#333333", "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Lato", "device": { "WT": { "marginBottom": 0, "marginTop": 0, "qrdim": 250 }, "M": { "marginBottom": 0, "marginTop": 0, "qrdim": 180 }, "P": { "marginBottom": 0, "marginTop": 0, "qrdim": 230 } } }, { "component": "EMPTYSPACE", "value": "Thin" }, { "component": "TEXT", "content": "Bob & Alice | 17-09-2022", "fontStyle": "italic", "fontWeight": "normal", "fontFamily": "Lato", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 18, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 16, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 18, "marginBottom": 0, "marginTop": 0 } } }, { "component": "EMPTYSPACE", "value": "Thin" }],
        },
        {
            title: 'Capture Photos',
            description: '',
            bgcolor: '#fffff8',
            data: [{ "component": "TEXT", "content": "Capture", "fontStyle": "normal", "fontWeight": "bold", "fontFamily": "Parisienne", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 100, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 60, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 90, "marginBottom": 0, "marginTop": 0 } } }, { "component": "TEXT", "content": "The", "fontStyle": "normal", "fontWeight": "bold", "fontFamily": "Parisienne", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 55, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 30, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 50, "marginBottom": 0, "marginTop": 0 } } }, { "component": "TEXT", "content": "LOVE", "fontStyle": "normal", "fontWeight": "bold", "fontFamily": "Parisienne", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 100, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 60, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 90, "marginBottom": 0, "marginTop": 0 } } }, { "component": "TEXT", "content": "PLEASE SHARE YOUR\nPHOTOS OF US!", "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Quicksand", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 25, "marginBottom": 20, "marginTop": 0 }, "M": { "fontSize": 16, "marginBottom": 15, "marginTop": 0 }, "P": { "fontSize": 20, "marginBottom": 25, "marginTop": 10 } } }, { "component": "QR", "url": "wwww.neopets.com", "color": "#333333", "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Lato", "device": { "WT": { "marginBottom": 0, "marginTop": 0, "qrdim": 250 }, "M": { "marginBottom": 0, "marginTop": 0, "qrdim": 180 }, "P": { "marginBottom": 0, "marginTop": 0, "qrdim": 230 } } }, { "component": "TEXT", "content": "SIMPLY SCAN WITH  YOUR\nSMARTPHONE AND UPLOAD", "fontStyle": "normal", "fontWeight": "normal", "fontFamily": "Quicksand", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 25, "marginBottom": 0, "marginTop": 20 }, "M": { "fontSize": 16, "marginBottom": 0, "marginTop": 15 }, "P": { "fontSize": 20, "marginBottom": 0, "marginTop": 25 } } }, { "component": "EMPTYSPACE", "value": "Thin" }, { "component": "TEXT", "content": "Bob & Alice | 17-09-2022", "fontStyle": "italic", "fontWeight": "normal", "fontFamily": "Quicksand", "textAlign": "center", "url": "", "color": "#333333", "device": { "WT": { "fontSize": 18, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 16, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 18, "marginBottom": 0, "marginTop": 0 } } }, { "component": "EMPTYSPACE", "value": "Thin" }],
        },
        // {
        //     title: 'Wedding Website',
        //     description: '',
        //     data: [],
        // },
    ]
}

function useLongPress() {
    return function (callback) {
        let timeout;
        let preventClick = false;

        function start() {
            timeout = setInterval(() => {
                preventClick = true;
                callback();
            }, 100);
        }

        function clear() {
            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }

            timeout && clearInterval(timeout);
            preventClick = false;
        }

        function clickCaptureHandler(e) {
            if (preventClick) {
                e.stopPropagation();
                preventClick = false;
            }
        }

        return {
            onMouseDown: start,
            onTouchStart: start,
            onMouseUp: clear,
            onMouseLeave: clear,
            onTouchMove: clear,
            onTouchEnd: clear,
            onClickCapture: clickCaptureHandler
        };
    }
}

function Qredit(props) {

    const { token } = Retrieve_personal_info()
    const device = Checkdevice()
    const [loaded, setLoaded] = useState(false)
    const [returnhome, setReturnhome] = useState(false)

    const [id, setId] = useState('')
    const [urlhandler, setUrlhandler] = useState('') // invitation url handler
    const [passcode, setPasscode] = useState('')
    const [bgcolor, setBgcolor] = useState('')
    const [qrobjs, setQrobjs] = useState([]) // array of objects , where each is a component. components are : TEXT, BANNER, TIMELINE, EMPTYSPACE

    // simulator device 
    const [simulatordevice, setSimulatordevice] = useState('WT')// WT, M

    // pringing size
    const [printingsize, setPrintingsize] = useState({ width: 0, height: 0 })

    // content - NONE, TEMPLATE, ADD, TEXT, BANNER, TIMELINE
    const [rightcontentkey, setRightcontentkey] = useState('NONE')

    // index of comp selected to edit
    const [selectededitindex, setSelectededitindex] = useState(-1)

    // index to add comp
    const [selectedaddindex, setSelectedaddindex] = useState(-1)

    // add component to top or btm of the selectededitindex - '', 'TOP', 'BTM'
    const [toporbtm, setToporbtm] = useState('')

    // selectedtlmenubtn, select menu Title, Content, Time
    const [selectedtlmenubtn, setSelectedtlmenubtn] = useState('Title')

    // delete btn
    const [delgate, setDelgate] = useState(false)

    // grid
    const [grid, setGrid] = useState(false)

    // download gate
    const [allowedit, setAllowedit] = useState(true)

    // frame 
    const [frame, setFrame] = useState(0)
    const [framecolor, setFramecolor] = useState('black')
    const [framecorner, setFramecorner] = useState(0)
    const [framethickness, setFramethickness] = useState(1)
    const [framestroke, setFramestroke] = useState('dashed')

    // save block
    const [blocksave, setBlocksave] = useState(false)

    const [notitxt, setNotitxt] = useState('')

    // new template replacement
    const [cfmaddnewtemplate, setCfaddnewtemplate] = useState(false)
    const [newtemplatedata, setNewtemplatedata] = useState([])
    const [newtemplatebgcolor, setNewtemplatebgcolor] = useState('')

    // downloadmodal
    const [downloadmodal, setDownloadmodal] = useState(false)
    const [downloadsize, setDownloadsize] = useState('A3')
    const [downloadtransparent, setDownloadtransparent] = useState(false) // transparent if is true, for download
    const [downloadchart, setDownloadchart] = useState(false)

    // to off the edit of component
    const [hover, setHover] = useState(false)

    const onLongPress = useLongPress();

    useEffect(() => {
        props.hidetopbar(true)
        let id = props.match.params.id
        axios({
            method: 'POST',
            url: READ_SINGLEQR,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { id }
        })
            .then((qrobj) => {
                const { message, qr } = qrobj.data
                const {
                    qrobjs,
                    urlhandler,
                    passcode,
                    bgcolor,
                    frame, framethickness, framecolor, framecorner, framestroke,
                    printingsize
                } = qr

                setLoaded(true)
                if (message === 'SUCCESS') {
                    setId(id)
                    setQrobjs(qrobjs)
                    setUrlhandler(urlhandler)
                    setPasscode(passcode)
                    setFrame(frame)
                    setFramethickness(framethickness)
                    setFramecolor(framecolor)
                    setFramecorner(framecorner)
                    setFramestroke(framestroke)
                    setPrintingsize(printingsize)
                    setBgcolor(bgcolor)
                }
            }).catch((e) => {
                props.history.push('/')
            })
        return () => props.hidetopbar(false)
    }, [])

    useEffect(() => {
        if (!downloadmodal) {
            setDownloadtransparent(false)
        }
    }, [downloadmodal])

    useEffect(() => {
        if (downloadchart) {
            setTimeout(() => {
                html2canvas(document.getElementById('Itinerarylookup_root'), {
                    allowTaint: false,
                    useCORS: true,
                    logging: true,
                    scrollX: 0,
                    scrollY: -window.scrollY,
                    backgroundColor: downloadtransparent ? null : bgcolor
                })
                    .then(async (canvas) => {// download happens here
                        const link = document.createElement("a");
                        link.download = Math.random() + ".png";
                        document.body.appendChild(link);
                        canvas.toBlob(function (b) {
                            changeDpiBlob(b, 300)
                                .then(function (blob) {
                                    link.href = window.URL.createObjectURL(blob);
                                    link.click()
                                    setAllowedit(true)
                                    setDownloadchart(false)
                                })
                        })
                        document.body.removeChild(link);
                    })
                    .catch(e => { alert('fail to download') })
            }, 1000)

        }
    }, [downloadchart])

    // const download = () => {
    //     setTimeout(() => {
    //         html2canvas(document.getElementById('Itinerarylookup_root'), {
    //             allowTaint: true,
    //             useCORS: true,
    //             logging: true,
    //             backgroundColor: 'white',
    //             scrollX: 0,
    //             scrollY: -window.scrollY,
    //         })
    //             .then(async (canvas) => {// download happens here
    //                 const link = document.createElement("a");
    //                 link.download = Math.random() + ".png";
    //                 document.body.appendChild(link);
    //                 canvas.toBlob(function (b) {
    //                     changeDpiBlob(b, 300)
    //                         .then(function (blob) {
    //                             link.href = window.URL.createObjectURL(blob);
    //                             link.click()
    //                             setAllowedit(true)
    //                         })
    //                 })
    //                 document.body.removeChild(link);
    //             })
    //             .catch(e => { alert('fail to download') })
    //     }, 5000)
    // }


    const deletefunc = () => {
        setDelgate(!delgate)
    }

    const timersequence = (run, msg) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                setNotitxt(msg)  // SHOW THIS MSG FIRST
                setTimeout(() => { // after timeone, run will be executed.
                    run();
                    resolve(
                        {
                            'Saved': 'SUCCESS',
                            'Failed': 'FAILURE',
                            'Failed': 'ALRDY_EXIST',
                        }[msg]
                    ); // Resolve the promise when the timers are done
                }, 1250);
            }, 1250);
        });
    };

    const save = () => {
        setBlocksave(true)
        setNotitxt('Saving...')
        let options = {
            method: 'POST',
            url: SAVE_SINGLEQR,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }, //need token from the web
            data: { id, urlhandler, passcode, bgcolor, qrobjs, frame, framecolor, framecorner, framethickness, framestroke }
        }
        axios(options).then((result) => {
            const { data, status } = result
            const { message } = data
            if (status === 200) {
                timersequence(
                    () => {
                        setBlocksave(false)
                        if (message === 'SUCCESS') {
                            setNotitxt('')
                        }
                    },
                    {
                        'SUCCESS': 'Saved',
                        'FAILURE': 'Failed'
                    }[message]
                )
            }
        }).catch(e => { })
    }


    const preview = () => {
        document.getElementById('iepreview_btninvisible').click()
    }

    // right content close button
    const closebtn = <button
        className="Itineraryedit_closebtn"
        onClick={() => {
            setRightcontentkey('NONE');
            setSelectededitindex(-1);
            setSelectedaddindex(-1)
            setToporbtm('');
        }}>
        <svg
            className="icon"
            style={{ ...s_, width: 32, height: 32, borderRadius: '100%', backgroundColor: 'white' }}
            viewBox={vb_}
            version={v_}
            xmlns={x_}
        >
            <path style={{ fill: '#333333', }} d="M442.24 517.504l-114.88 115.2a48 48 0 1 0 67.968 67.776l114.688-115.008L624.768 700.48a48 48 0 0 0 67.968-67.84l-114.88-115.136 114.88-115.072a48 48 0 1 0-67.968-67.84L510.016 449.6 395.328 334.592a48 48 0 0 0-67.968 67.84l114.88 115.072zM512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z" fill="#666666" p-id="10405"></path>
        </svg>
    </button>

    // component delete button
    const delbtn = <div style={{ display: 'flex', left: 0, position: 'absolute' }}>
        <button className="itinerary_deletedbtn" onClick={deletefunc}>
            {iconwrapper(TRASH_ICON, { width: 23, height: 23 })}
            <div style={{ paddingLeft: 7 }}>Delete</div>
        </button>
    </div>


    const text_fontsize_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['fontSize'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const text_fontsize_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['fontSize'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const text_topspace_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['marginTop'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const text_topspace_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['marginTop'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const text_btmspace_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['marginBottom'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const text_btmspace_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['marginBottom'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_size_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingRight'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_size_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingRight'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_topspace_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingTop'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_topspace_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingTop'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_btmspace_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingBottom'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const banner_btmspace_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['paddingBottom'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const qr_dim_dec = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['qrdim'] -= 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }
    const qr_dim_inc = () => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex]['device'][simulatordevice]['qrdim'] += 1
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }

    const clickthickness = (e) => {
        let curr_qrobjs = qrobjs.slice()
        curr_qrobjs[selectededitindex].value = e.target.value
        setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
    }

    const framecorner_inc = () => {
        setFramecorner((newval) => {
            return newval + 1
        })
    }

    const framecorner_dec = () => {
        setFramecorner((newval) => {
            return newval - 1
        })
    }

    const bar_wt_dom = <div style={{ width: '100%', borderBottom: '1px solid #dddddd', padding: 10, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1040 }}>
        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center', pointerEvents: 'none', userSelect: 'none', opacity: 0 }}></div>
        <button className="planning_backicon" style={{ position: 'absolute', left: 10, }} onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center' }}></div>
        <div className="ie_previewbtn_root" style={{ position: 'relative', height: 'max-content', margin: 0, right: 0 }}>
            <button className="scedit_savingbtn" style={{ marginRight: 5 }} disabled={blocksave} onClick={save}>Save</button>
            <button className="iepreview_btn" style={{ margin: 0 }} onClick={preview}>
                {LOOKUPUNSTYLE_ICON} Preview
                <Link id="iepreview_btninvisible" to={'/qrlookup/' + urlhandler + '/passcode=' + passcode} target="_blank" />
            </button>
        </div>
    </div>

    const bar_m_dom = <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
        <div style={{ width: '100%', padding: '0px 10px', height: 60, borderBottom: '1px solid #dddddd', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 'max-content', userSelect: 'none' }}>
            <button className="planning_backicon" onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
            <button className="iepreview_btn" style={{ margin: 0 }} onClick={() => { document.getElementById('iepreview_btninvisible').click() }}>
                {LOOKUPUNSTYLE_ICON} Preview
                <Link id="iepreview_btninvisible" to={'/timelinelookup/' + urlhandler + '/passcode=' + passcode} target="_blank" />
            </button>
        </div>
    </div>


    const topbar = { 'WEB': bar_wt_dom, 'TABLET': bar_wt_dom, 'MOBILE': bar_m_dom }[device]

    // home modcfm start
    const home_mod = returnhome
        ? <Modcfm
            onHide={() => { setReturnhome(false) }}
            onOk={() => { props.history.push(PLOBJ['qr']['toolurl']) }}
            onNo={() => { setReturnhome(false) }}
            txt={'You are returning to planning tools menu.'}
        /> : null

    // mobile not supported start
    const mobile_not_supported = device === 'MOBILE'
        ? <div id='itineraryedit_mobilebtm'>
            <div style={{ padding: 10, display: 'flex', textAlign: 'center' }}>Sorry, this feature is currently only supported on a desktop or laptop and is not available on mobile devices.</div>
            <button id='itineraryedit_mobilebtmbtn' onClick={() => props.history.push('/')}>Home</button>
        </div>
        : null

    const tlobjsexist = qrobjs && qrobjs.length === 0

    const left_template_or_add_dom = <div id='itineraryedit_leftcontentroot'>
        <button
            className='itineraryedit_leftbtn'
            value={'TEMPLATE'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}
        >
            Template
        </button>
        <div id='itineraryedit_or'>OR</div>
        <button
            className='itineraryedit_leftbtn'
            value={'ADD'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}>
            +
        </button>
    </div>

    const addrightcomp = (e) => {
        const { value } = e.target
        const curr_qrobjs = JSON.parse(JSON.stringify(qrobjs))
        let newitem
        if (value === 'TEXT') {
            newitem = {
                component: 'TEXT',
                content: 'Some text ',
                fontStyle: 'normal', // normal or italic
                fontWeight: 'normal', // normal or bold
                fontFamily: 'Lato',
                textAlign: 'center', // flex-start, center, flex-end
                url: '',// clickable link for redirect when content clicked.
                color: '#333333', // font color            
                device: {
                    'WT': { // WEB or TABLET
                        fontSize: 18,
                        marginBottom: 0,
                        marginTop: 0
                    },
                    'M': { // MOBILE
                        fontSize: 16,
                        marginBottom: 0,
                        marginTop: 0
                    },
                    'P': {
                        fontSize: 18,
                        marginBottom: 0,
                        marginTop: 0
                    }
                }
            }
        }
        else if (value === 'BANNER') {
            newitem = {
                component: 'BANNER',
                url: '',
                device: {
                    'WT': { // WEB or TABLET
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,

                    },
                    'M': { // MOBILE
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                    },
                    'P': {
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,

                    }
                }
            }
        }
        else if (value === 'EMPTYSPACE') {
            newitem = {
                component: 'EMPTYSPACE',
                value: 'Thin',
            }
        }
        else if (value === 'QR') {
            newitem = {
                component: 'QR',
                url: 'wwww.neopets.com', // URL to generate qr code
                color: '#333333', // color of qr      
                fontStyle: 'normal', // normal or italic
                fontWeight: 'normal', // normal or bold
                fontFamily: 'Lato',
                device: {
                    'WT': { // WEB or TABLET
                        marginBottom: 0,
                        marginTop: 0,
                        qrdim: 250,
                    },
                    'M': { // MOBILE
                        marginBottom: 0,
                        marginTop: 0,
                        qrdim: 180,
                    },
                    'P': {
                        marginBottom: 0,
                        marginTop: 0,
                        qrdim: 150,
                    }
                }
            }
        }

        if (toporbtm.length > 0) {
            let newindexing
            if (toporbtm === 'TOP') {
                curr_qrobjs.splice(selectedaddindex, 0, newitem)
                newindexing = selectedaddindex
            }
            else if (toporbtm === 'BTM') {
                curr_qrobjs.splice(selectedaddindex + 1, 0, newitem)
                newindexing = selectedaddindex + 1
            }
            setQrobjs(curr_qrobjs)
            setRightcontentkey(value)
            setSelectededitindex(newindexing)
            setSelectedaddindex(-1)
        }
        else {
            curr_qrobjs.push(newitem)
            setSelectededitindex(0)
            setSelectedaddindex(-1)
            setQrobjs(curr_qrobjs)
            setRightcontentkey(value)
        }

    }

    const alldevicesbtns = <Togglebutton
        singlebtnstyle={{ width: 40, height: 40 }}
        funcs={[
            () => setSimulatordevice('WT'),
            () => setSimulatordevice('M'),
            () => setSimulatordevice('P') // print
        ]}
        txts={[
            iconwrapper(LAPTOP_ICON, { width: 25, height: 25 }),
            iconwrapper(MOBILE_ICON, { width: 25, height: 25 }),
            iconwrapper(PRINT_ICON, { width: 25, height: 25 })
        ]}
        btnselected={{ 'WT': 0, 'M': 1, 'P': 2 }[simulatordevice]}
    />

    const iconsize = { 'WEB': 30, 'TABLET': 25, 'MOBILE': 0 }[device]

    const left_dom = <div
        className={`itineraryedit_left itineraryedit_left${device} sketchbg`}
        onClick={() => setHover(!hover)}
    >
        <div className={`itineraryedit_devicebtns${device}`}>

            <div style={{ display: 'flex', flexDirection: 'row', width: 'calc((100% - 122px )/2)' }}>

                <button
                    className="itinerary_colorbtn"
                    style={grid ? { color: 'var(--mainpink)', marginLeft: 0 } : { color: 'var(--maindark)', marginLeft: 0 }}
                    onClick={() => setGrid(!grid)}
                >
                    {iconwrapper(GRID_ICON, { width: iconsize, height: iconsize })}
                </button>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'TEMPLATE' ? { color: 'var(--mainpink)', marginLeft: simulatordevice === 'p' ? 0 : 5 } : { color: 'var(--maindark)', marginLeft: simulatordevice === 'p' ? 0 : 5 }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'TEMPLATE' ? '' : 'TEMPLATE')}
                >
                    {iconwrapper(ITINERARYTEMPLATE_ICON, { width: iconsize, height: iconsize })}
                </button>

            </div>

            {alldevicesbtns}

            <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end', width: 'calc((100% - 122px )/2)' }}>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'FRAME' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'FRAME' ? '' : 'FRAME')}
                >
                    {iconwrapper(FRAME_ICON, { width: iconsize, height: iconsize })}
                </button>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'COLOR' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'COLOR' ? '' : 'COLOR')}
                >
                    {iconwrapper(COLOR_ICON, { width: iconsize, height: iconsize })}
                </button>

                {simulatordevice === 'P'  // allow RESIZE btn if is P - Printing Mode
                    ? <button
                        className="itinerary_colorbtn"
                        style={rightcontentkey === 'PRINTINGSIZE' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                        onClick={() => setRightcontentkey(rightcontentkey === 'PRINTINGSIZE' ? '' : 'PRINTINGSIZE')}
                    >
                        {iconwrapper(RESIZE_ICON, { width: iconsize, height: iconsize })}
                    </button>
                    : null}


                {simulatordevice === 'P'
                    ? <button
                        className='scedit_qrbtn'
                        style={{ margin: ' 0px 0px 0px 5px', right: 0 }}
                        onClick={() => {
                            setAllowedit(false)
                            setSelectededitindex(-1)
                            setRightcontentkey('')

                            // download()
                            setDownloadmodal(true)
                        }}
                    >
                        {iconwrapper(DOWNLOAD_ICON, { width: iconsize, height: iconsize })}
                    </button>
                    : null}

            </div>
        </div>
        {tlobjsexist
            ? left_template_or_add_dom
            : <Qrlookup
                from='EDIT'
                downloadmodal={downloadmodal}
                hover={hover}
                grid={grid}
                allowedit={allowedit}
                downloadtransparent={downloadtransparent}
                selectededitindex={selectededitindex}
                simulatordevice={simulatordevice}
                qrobjs={qrobjs}
                bgcolor={bgcolor}
                frame={frame}
                framecolor={framecolor}
                framecorner={framecorner}
                framestroke={framestroke}
                framethickness={framethickness}
                onDragEnd={(result) => {

                    setRightcontentkey('NONE');
                    setSelectededitindex(-1);
                    setSelectedaddindex(-1)
                    setToporbtm('');

                    const { source, destination } = result
                    if (!destination) { return }

                    let curr_qrobjs = qrobjs.slice()
                    const [removed] = curr_qrobjs.splice(source.index, 1);
                    curr_qrobjs.splice(destination.index, 0, removed);

                    setQrobjs(curr_qrobjs)
                }}

                edit={(index, component) => {// pencil edit for each component
                    setSelectededitindex(index)
                    setRightcontentkey(component)
                }}
                addtop={(index) => {
                    setRightcontentkey('ADD')
                    setSelectedaddindex(index)
                    setToporbtm('TOP')
                }}
                addbtm={(index) => {
                    setRightcontentkey('ADD')
                    setSelectedaddindex(index)
                    setToporbtm('BTM')
                }}
            />}
    </div>

    const right_dom = <div className={`itineraryedit_right itineraryedit_right${device}`}>
        {{
            // will appear if user is first time using
            NONE: <></>,

            // will appear if user is first time using
            TEMPLATE: <div className="itinerary_rightcontentroot">
                {closebtn}
                {Object.keys(TEMPLATE_CONTENT).map((maintitle, i) => {
                    return <div key={maintitle + i} className="itineraryedit_templateroot">
                        <div className="itinerary_templatetitle">{maintitle}</div>
                        <div className="itinerary_templatecontent">
                            {TEMPLATE_CONTENT[maintitle].map((item, index) => {
                                const { title, data, bgcolor } = item // description,
                                const newdata = JSON.stringify(data)
                                const addnewtemplate = () => {
                                    setCfaddnewtemplate(true)
                                    setNewtemplatedata(JSON.parse(newdata))
                                    setNewtemplatebgcolor(bgcolor)
                                }
                                return <button onClick={addnewtemplate} className="Itineraryedit_rightcontentrootbtn" key={index + 'template'} style={{ placeContent: 'center', display: 'flex', textAlign: 'center', alignItems: 'start' }}>
                                    <div>{title}</div>
                                    {/* <div>{description}</div> */}
                                </button>
                            })}
                        </div>
                    </div>
                })}
            </div>,

            // will appear if user is first time using
            ADD: <div className="itinerary_rightcontentroot">
                {closebtn}
                <button className="Itineraryedit_rightcontentrootbtn" onClick={addrightcomp} value={'TEXT'}>Text</button>
                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'BANNER'}>Banner</button>
                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'EMPTYSPACE'}>Empty Space</button>
                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'QR'}>QR</button>
            </div>,


            TEXT: selectededitindex > -1 && rightcontentkey === 'TEXT'
                ? <div className="itinerary_rightcontentroot" >
                    {delbtn}
                    {closebtn}

                    {/* content */}
                    {textarea_dom(
                        'Content',
                        'Some Content',
                        qrobjs[selectededitindex].content,
                        (e) => {
                            const { value } = e.target
                            let curr_qrobjs = JSON.parse(JSON.stringify(qrobjs))
                            curr_qrobjs[selectededitindex].content = value
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                        },
                        'qrobj' + selectededitindex,
                        {},
                        false,
                        null,
                        {},
                        txtarea_css,
                        3,
                        null
                    )}
                    <div style={{ height: 10 }} />

                    {/* font-family */}
                    {multiplechoice_dom(
                        'Font Family',
                        ENGLISH_FF,
                        (e) => {
                            const { value } = e.target
                            let curr_qrobjs = JSON.parse(JSON.stringify(qrobjs))
                            curr_qrobjs[selectededitindex].fontFamily = value
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                        },
                        'FF_ID',
                        [],
                        qrobjs[selectededitindex].fontFamily
                    )}

                    {/* font-style & font-weight */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Font Settings', {})}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 5px',
                                    backgroundColor: qrobjs[selectededitindex]['fontStyle'] === 'italic' ? 'var(--mainpink)' : '#ffffff',
                                    color: qrobjs[selectededitindex]['fontStyle'] === 'italic' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_qrobjs = qrobjs.slice()
                                    qrobjs[selectededitindex]['fontStyle'] = qrobjs[selectededitindex]['fontStyle'] === 'italic' ? 'normal' : 'italic'
                                    setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                                }}
                            >
                                Italic
                            </button>
                            <div style={{ height: 40, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 5px 0px',
                                    backgroundColor: qrobjs[selectededitindex]['fontWeight'] === 'bold' ? 'var(--mainpink)' : '#ffffff',
                                    color: qrobjs[selectededitindex]['fontWeight'] === 'bold' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_qrobjs = qrobjs.slice()
                                    qrobjs[selectededitindex]['fontWeight'] = qrobjs[selectededitindex]['fontWeight'] === 'bold' ? 'normal' : 'bold'
                                    setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                                }}
                            >
                                Bold
                            </button>
                        </div>
                    </div>

                    <div style={{ height: 10 }} />

                    {/* text-align */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Text-align', {})}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRadius: '5px 0px 0px 5px',
                                    borderRight: 'none',
                                    backgroundColor: qrobjs[selectededitindex]['textAlign'] === 'start' ? 'var(--mainpink)' : '#ffffff',
                                    color: qrobjs[selectededitindex]['textAlign'] === 'start' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_qrobjs = qrobjs.slice()
                                    qrobjs[selectededitindex]['textAlign'] = 'start'
                                    setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                                }}
                            >
                                Start
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none', borderLeft: 'none',
                                    backgroundColor: qrobjs[selectededitindex]['textAlign'] === 'center' ? 'var(--mainpink)' : '#ffffff',
                                    color: qrobjs[selectededitindex]['textAlign'] === 'center' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_qrobjs = qrobjs.slice()
                                    qrobjs[selectededitindex]['textAlign'] = 'center'
                                    setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                                }}
                            >
                                Center
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRadius: '0px 5px 5px 0px',
                                    borderLeft: 'none',
                                    backgroundColor: qrobjs[selectededitindex]['textAlign'] === 'end' ? 'var(--mainpink)' : '#ffffff',
                                    color: qrobjs[selectededitindex]['textAlign'] === 'end' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_qrobjs = qrobjs.slice()
                                    qrobjs[selectededitindex]['textAlign'] = 'end'
                                    setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                                }}
                            >
                                End
                            </button>
                        </div>
                    </div>

                    <div style={{ height: 10 }} />

                    {/* device specific */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'WT' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'WT' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='WT'
                            >
                                Web/Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
                        {/* device specific - fontsize */}
                        {partialtitle_dom('Font-size', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_fontsize_dec}
                                {...onLongPress(text_fontsize_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['fontSize']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_fontsize_inc}
                                {...onLongPress(text_fontsize_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {/* device specific - marginTop & marginBottom */}
                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_dec}
                                {...onLongPress(text_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['marginTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_inc}
                                {...onLongPress(text_topspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_inc}
                                {...onLongPress(text_btmspace_inc)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['marginBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_dec}
                                {...onLongPress(text_btmspace_dec)}
                            >
                                +
                            </button>
                        </div>

                    </div>
                    <div style={{ height: 10 }} />

                    {/* url input */}
                    {/* {input_dom(
                        'URL',
                        '',
                        qrobjs[selectededitindex]['url'],
                        (e) => {
                            let curr_qrobjs = qrobjs.slice()
                            qrobjs[selectededitindex]['url'] = e.target.value
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                        },
                        'url_id',
                        {},
                        false,
                        null,
                        {},
                        { width: 'calc(100% - 20px)', margin: '0px 10px' }
                    )} */}

                    <div style={{ height: 10 }} />
                    {/* color */}
                    {partialtitle_dom('Font Color', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <HexColorPicker
                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                        color={qrobjs[selectededitindex]['color']}
                        onChange={(e) => {
                            let curr_qrobjs = qrobjs.slice()
                            qrobjs[selectededitindex]['color'] = e
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                        }} />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                        <HexColorInput
                            color={qrobjs[selectededitindex]['color']}
                            onChange={(e) => {
                                let curr_qrobjs = qrobjs.slice()
                                qrobjs[selectededitindex]['color'] = e
                                setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                            }}
                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                        />
                    </div>
                    {/* {JSON.stringify(qrobjs[selectededitindex])} */}
                    <div style={{ height: 100 }} />
                </div>
                : null,

            BANNER: selectededitindex > -1 && rightcontentkey === 'BANNER'
                ? <div className="itinerary_rightcontentroot">
                    {delbtn}
                    {closebtn}

                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column', placeContent: 'center', margin: '0px 10px' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'WT' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'WT' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='WT'
                            >
                                Web/Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

                        {/* device specific - paddingleft and paddingRight, control the size of banner*/}
                        {partialtitle_dom('Size of banner', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_size_dec}
                                {...onLongPress(banner_size_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['paddingRight']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_size_inc}
                                {...onLongPress(banner_size_inc)}
                            >
                                +
                            </button>
                        </div>

                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_topspace_dec}
                                {...onLongPress(banner_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['paddingTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_topspace_inc}
                                {...onLongPress(banner_topspace_inc)}
                            >
                                +
                            </button>
                        </div>

                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_btmspace_dec}
                                {...onLongPress(banner_btmspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['paddingBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_btmspace_inc}
                                {...onLongPress(banner_btmspace_inc)}
                            >
                                +
                            </button>
                        </div>

                    </div>

                    <div style={{ height: 10 }} />

                    <div style={{ width: 'calc( 100% - 20px )' }}>
                        {partialtitle_dom('Banners', {})}
                        <Banners
                            select={({ index }) => {
                                let url
                                if (index > 0) {
                                    url = banners[index]
                                }
                                else {
                                    url = ''
                                }
                                let curr_qrobjs = qrobjs.slice()
                                qrobjs[selectededitindex]['url'] = url
                                setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                            }}
                            selected={qrobjs[selectededitindex]['url']}
                            banners={banners}
                            names={bannernames}
                        />
                    </div>

                    <div style={{ height: 100 }} />
                </div>
                : null,

            EMPTYSPACE: selectededitindex > -1 && rightcontentkey === 'EMPTYSPACE'
                ? <div className="itinerary_rightcontentroot">
                    {delbtn}
                    {closebtn}
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={qrobjs[selectededitindex].value === 'Thin'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Thin'
                        >
                            Thin
                        </button>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={qrobjs[selectededitindex].value === 'Medium'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Medium'
                        >
                            Medium
                        </button>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={qrobjs[selectededitindex].value === 'Large'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Large'
                        >
                            Large
                        </button>
                    </div>
                </div>
                : null,

            COLOR: rightcontentkey === 'COLOR'
                ? <div className="itinerary_rightcontentroot">
                    {closebtn}
                    {partialtitle_dom('Background Color ', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <HexColorPicker
                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                        color={bgcolor}
                        onChange={(e) => {
                            setBgcolor(e)
                        }} />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                        <HexColorInput
                            color={bgcolor}
                            onChange={(e) => {
                                setBgcolor(e)
                            }}
                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                        />
                    </div>
                </div>
                : null,

            FRAME: rightcontentkey === 'FRAME'
                ? <div className="itinerary_rightcontentroot">
                    {closebtn}

                    <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                        {radiobtn_dom(
                            frame === 0,
                            () => {
                                setFrame(frame === 0 ? -1 : 0)
                            },
                            frame === 0 ? `Frame Enabled` : `Frame Disabled`,
                            { width: '100%' }
                        )}
                    </div>

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Color ', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                            <HexColorPicker
                                style={{ height: 200, width: 'calc( 100% - 20px )' }}
                                color={framecolor}
                                onChange={(e) => { setFramecolor(e) }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput
                                    color={framecolor}
                                    onChange={(e) => { setFramecolor(e) }}
                                    style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                />
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Thickness', {})}
                            <div key={'styleborderwt' + framethickness} className='border_menu3' style={{ border: '1px solid var(--subgrey)', width: '100%', padding: 10, borderRadius: 5 }}>
                                <div
                                    className={`border_brthickthin  ${framethickness === 5 ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramethickness(framethickness === 5 ? 0 : 5) }} >
                                    <div className='border_brthickcontent' />
                                </div>
                                <div
                                    className={`border_brthickthin ${framethickness === 1 ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramethickness(framethickness === 1 ? 0 : 1) }}
                                >
                                    <div className='border_brthincontent' />
                                </div>
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Stroke', {})}
                            <div key={'styleborderwt' + framestroke} className='border_menu3' style={{ border: '1px solid var(--subgrey)', width: '100%', padding: 10, borderRadius: 5 }}>
                                <div
                                    className={`border_brthickthin ${framestroke === 'solid' ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramestroke(framestroke === 'solid' ? '' : 'solid') }}
                                >
                                    <div className='border_brthickcontent' style={{ border: '1px solid var(--maindark)' }} />
                                </div>
                                <div
                                    className={`border_brthickthin ${framestroke === 'dashed' ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramestroke(framestroke === 'dashed' ? '' : 'dashed') }}
                                >
                                    <div className='border_brthincontent' style={{ border: '1px dashed var(--maindark)' }} />
                                </div>
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />


                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Corner', {})}
                            <div className="Itinerary_rightcontentsubcompfsroot">
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{ borderRadius: 20, fontSize: 18 }}
                                    onClick={framecorner_dec}
                                    {...onLongPress(framecorner_dec)}
                                >
                                    -
                                </button>
                                <div className="itinerary_rightcontentnum">{framecorner}</div>
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{ borderRadius: 20, fontSize: 18 }}
                                    onClick={framecorner_inc}
                                    {...onLongPress(framecorner_inc)}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                        : null}




                </div>
                : null,

            PRINTINGSIZE: rightcontentkey === 'PRINTINGSIZE'
                ? <div className="itinerary_rightcontentroot">
                    {closebtn}
                    {partialtitle_dom('Sizing', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    {inputdescribe_dom('Currently only support 1/3 A4 long sizing.', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <button
                        className="Itineraryedit_rightcontentrootbtn"
                        style={JSON.stringify(printingsize) === '{"width":584.666667,"height":826.666667}'
                            ? { backgroundColor: 'var(--mainpink)', color: '#ffffff' }
                            : {}}
                        onClick={() => {
                        }}>
                        Long 1/3 A4
                    </button>

                </div>
                : null,

            QR: rightcontentkey === 'QR'
                ? <div className="itinerary_rightcontentroot" >
                    {delbtn}
                    {closebtn}

                    {/* url input */}
                    {input_dom(
                        'URL',
                        '',
                        qrobjs[selectededitindex]['url'],
                        (e) => {
                            let curr_qrobjs = qrobjs.slice()
                            qrobjs[selectededitindex]['url'] = e.target.value
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                        },
                        'url_id',
                        {},
                        false,
                        null,
                        {},
                        { width: 'calc(100% - 20px)', margin: '0px 10px' }
                    )}
                    <div style={{ height: 10 }} />

                    {/* device specific */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'WT' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'WT' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='WT'
                            >
                                Web/Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

                        {/* device specific - marginTop & marginBottom */}
                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_dec}
                                {...onLongPress(text_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['marginTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_inc}
                                {...onLongPress(text_topspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_inc}
                                {...onLongPress(text_btmspace_inc)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['marginBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_dec}
                                {...onLongPress(text_btmspace_dec)}
                            >
                                +
                            </button>
                        </div>

                        <div style={{ height: 10 }} />
                        {partialtitle_dom('QR Dimension', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={qr_dim_dec}
                                {...onLongPress(qr_dim_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{qrobjs[selectededitindex]['device'][simulatordevice]['qrdim']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={qr_dim_inc}
                                {...onLongPress(qr_dim_inc)}
                            >
                                +
                            </button>
                        </div>

                    </div>

                    {/* {JSON.stringify(qrobjs[selectededitindex])} */}
                    <div style={{ height: 100 }} />
                </div>
                : null

        }[rightcontentkey]}
    </div>

    const newtemplatemodcfm = cfmaddnewtemplate
        ? <Modcfm
            onHide={() => { setCfaddnewtemplate(false) }}
            onOk={() => {
                const new_data = JSON.parse(JSON.stringify(newtemplatedata))
                setBgcolor(newtemplatebgcolor)
                setQrobjs(new_data)
                setCfaddnewtemplate(false)
                setNewtemplatedata([])
            }}
            onNo={() => { setCfaddnewtemplate(false) }}
            txt={'This action will replace your current timeline with the selected template. Please ensure that you are certain about this decision.'}
        />
        : null

    const delmodcfm = delgate
        ? <Modcfm
            onHide={() => { setDelgate(false) }}
            onOk={() => {
                let curr_qrobjs = JSON.parse(JSON.stringify(qrobjs))
                let data = {}
                console.log(' old ', curr_qrobjs)
                if (curr_qrobjs[selectededitindex].component === 'IMAGE') {
                    let urls = []// images to remove
                    const { coupleimg1, coupleimg2, singleimg } = curr_qrobjs[selectededitindex]
                    if (coupleimg1.length !== 0) urls.push(coupleimg1)
                    if (coupleimg2.length !== 0) urls.push(coupleimg2)
                    if (singleimg.length !== 0) urls.push(singleimg)
                    curr_qrobjs.splice(selectededitindex, 1)
                    data = { _id: id, urlhandler: urlhandler, qrobjs: JSON.parse(JSON.stringify(curr_qrobjs)), passcode }
                }
                else {
                    curr_qrobjs.splice(selectededitindex, 1)
                    data = { _id: id, urlhandler: urlhandler, qrobjs: JSON.parse(JSON.stringify(curr_qrobjs)), passcode }
                }
                console.log(' new ', curr_qrobjs)

                let options = {
                    method: 'POST',
                    url: REMOVE_QRCOMP,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }, //need token from the web
                    data: data
                }
                axios(options).then((result) => {
                    const { data, status } = result
                    const { message } = data
                    if (status === 200) {
                        if (message === 'SUCCESS') {
                            setDelgate(false)
                            setSelectededitindex(-1)
                            console.log('nkjnkjn', curr_qrobjs)
                            setQrobjs(JSON.parse(JSON.stringify(curr_qrobjs)))
                            setRightcontentkey('NONE')
                        }
                        else {
                            refresh()
                        }
                    }
                }).catch(e => { })

            }}
            onNo={() => { setDelgate(false) }}
            txt={'Once you delete this component, there is no going back. Please be certain.'}
        />
        : null

    const portalmidcss = { width: { 'WEB': 500, 'TABLET': 450, 'MOBILE': '100%' }[device], height: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device], backgroundColor: 'white', top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }
    const download_modal = <Portalmodal
        portaltype={'commonportal'}
        open={downloadmodal}
        onClose={() => {
            setDownloadmodal(false)
            setAllowedit(true)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Download"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">

                <div className="Details_grp" >
                    {partialtitle_dom('Background', {})}
                    <div className="Scdesign_portalrow">
                        {checkbox_dom(
                            downloadtransparent,
                            () => {
                                const txt = document.querySelector(".ce_checkboxtxt");
                                const checkbox = document.querySelector(".ce_checkbox");
                                checkbox.checked = !checkbox.checked;
                                setDownloadtransparent(!downloadtransparent)
                            },
                            'Transparent Background',
                        )}
                    </div>
                </div>

                <div className="Details_grp" >
                    {input_dom(
                        'File Type',
                        '.PNG',
                        '.PNG',
                        (e) => {
                        },
                        'png_id',
                        {},
                        true,
                        null,
                        {},
                        { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, }
                    )}
                </div>

                <button
                    className="scedit_modalbtn"
                    style={{ marginBottom: 0, marginTop: 0, borderRadius: 5 }}
                    disabled={downloadchart}
                    onClick={() => {
                        setDownloadchart(true)
                    }}>
                    {downloadchart ? 'Generating...' : 'Download'}
                </button>
            </div>
        </div>
    </Portalmodal>

    return !loaded
        ? <Loading ht={'100%'} />
        : <div id="itineraryedit_root" >
             <Etsydummypanel>
                Generate a digital or printable QR code to share online or display at the reception.
            </Etsydummypanel>
            {topbar}
            {home_mod}
            {device === 'MOBILE'
                ? null
                : <div id='itineraryedit_btm'>
                    {left_dom}
                    {right_dom}
                </div>}
            {mobile_not_supported}
            {delmodcfm}
            {newtemplatemodcfm}
            {notitxt && notitxt.length > 0 ? <Noti noti={notitxt} /> : null}
            {download_modal}
        </div>
}

export default Qredit